module.exports = __webpack_public_path__ + "img/72.9f0c4082.jpg";